require(["jquery"],function ($) {
	$("[role='pushmenu']").on("click", function () {
		toggleMenu();
		return false;
	});

	$(document).on("touchend", function (e) {
		var $target = $(e.target);
		if (isMenuOpened() && ($target.attr("role") != "pushmenu")) {
			if (!$target.hasClass("pushmenu") && !$target.parents(".pushmenu").length) {
				closeMenu();
			}
		}
	});
	$(document).on("click", function (e) {
		var $target = $(e.target);
		if (isMenuOpened() && ($target.attr("role") != "pushmenu")) {
			if (!$target.hasClass("pushmenu") && !$target.parents(".pushmenu").length) {
				closeMenu();
			}
		}
	});

	$(document).ready(function () {
		$(".pushmenu").height($(".pushmenu-content-container").height());
	});
	$(window).resize(function () {
		$(".pushmenu").height($(".pushmenu-content-container").height());
	});

	function isMenuOpened() {
		return $(".pushmenu").hasClass("pushmenu-open");
	}

	function toggleMenu() {
		$(".pushmenu").toggleClass("pushmenu-open");
		$(".pushmenu-content").toggleClass("pushmenu-content-open");
		$(".pushmenu-content-container").toggleClass("pushmenu-content-container-open");
	}

	function closeMenu() {
		$(".pushmenu").removeClass("pushmenu-open");
		$(".pushmenu-content").removeClass("pushmenu-content-open");
		$(".pushmenu-content-container").removeClass("pushmenu-content-container-open");
	}
});
define("pushmenu", function(){});

